<script setup>
import {computed, ref, watch} from "vue";

const props = defineProps({
    imagesObject: Array,
    hoveredImageUrl: String
})
const dialog = defineModel()

const findImageIndex = () => {
    if (!props.hoveredImageUrl || !props.imagesObject) return 0;
    const index = props.imagesObject.findIndex(media => media.url === props.hoveredImageUrl);
    return index >= 0 ? index : 0;
};

const currentIndex = ref(findImageIndex());

</script>

<template>
    <v-card class="d-flex">
        <v-carousel hide-delimiters height="80vh" touch :model-value="currentIndex">
            <v-carousel-item v-for="media in imagesObject" :key="media.id" :src="media.url" />
        </v-carousel>
        <v-card-actions class="pa-4">
            <v-btn
                class="ms-auto"
                text="Ok"
                @click="dialog = false"
            ></v-btn>
        </v-card-actions>
    </v-card>
</template>

<style scoped>

</style>